import { useQuery } from '@tanstack/react-query';

import { useFleet } from '../hooks/useFleet';
import { DeviceStatusService } from '../services/device-status.service';

interface Props {
  /** Do not refresh automatically if single is set to true */
  single?: boolean;
}

export const useDevicesLocation = (props: Props) => {
  const fleet = useFleet();
  const queryKey = ['devicesLocation', fleet?.id];

  const queryFn = () => DeviceStatusService.getDeviceLocations();

  return useQuery({
    queryKey,
    queryFn,
    refetchInterval: props?.single ? undefined : 1000 * 5,
    staleTime: props?.single ? 1000 * 60 : 1000 * 5, // 5 seconds
    cacheTime: 1000 * 60, // One minute
    enabled: !!fleet?.id,
  });
};
